// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".percentage-bar[data-v-1ecb5b28]{display:flex;flex-direction:row}.percentage-bar .percentage-value[data-v-1ecb5b28]{word-break:keep-all}", ""]);
// Exports
module.exports = exports;
